import * as translations from './locales';

export const fallbackLng = process.env.NEXT_PUBLIC_LANG ?? 'de';
export const languages = ['en', 'de'];
export const defaultNS = 'common';

export const getOptions = (lng = fallbackLng) => ({
  supportedLngs: languages,
  fallbackLng,
  lng,
  fallbackNS: defaultNS,
  defaultNS,
  resources: { ...translations },
  ns: ['common', 'items', 'glossary', 'login', 'orders', 'settings', 'pm'],
});
